import GDPRCookieBanner from './GDPRCookieBanner';

export default GDPRCookieBanner;
